import "./LabAdminDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LabAdminDetailsViewComponent from "./lab-admin-details-view/LabAdminDetailsViewComponent";
import LabAdminDetailsEditComponent from "./lab-admin-details-edit/LabAdminDetailsEditComponent";

interface LabAdminDetailsViewEditComponentProps {
    labDetails: any
    onUpdateAdminDetails: Function;
    onModeChange:Function;
    canEdit: boolean;
}

const LabAdminDetailsViewEditComponent = (props: LabAdminDetailsViewEditComponentProps) => {
    const {labDetails, onUpdateAdminDetails,onModeChange,canEdit} = props;

    const [mode, setMode] = useState<"view" | "edit">("view");
    const [labAdminDetails, setLabAdminDetails] = useState<any>(undefined);

    const handleAdminDetailsUpdate = useCallback((updatedAdminDetails: any) => {
        onUpdateAdminDetails(updatedAdminDetails);
        setMode("view");
    }, [onUpdateAdminDetails]);

    const handleAdminDetailsEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (labDetails) {
            setLabAdminDetails(labDetails?.adminDetails);
        }
    }, [labDetails]);

    useEffect(()=>{
        onModeChange(mode)
    },[mode,onModeChange])

    return (
        <div className={'admin-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <LabAdminDetailsViewComponent
                    labAdminDetails={labAdminDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <LabAdminDetailsEditComponent labAdminDetails={labAdminDetails}
                                                              labDetails={labDetails}
                                                              onUpdateComplete={handleAdminDetailsUpdate}
                                                              onEditCancel={handleAdminDetailsEditCancel}
                />
            }
        </div>
    );

};

export default LabAdminDetailsViewEditComponent;